module.exports = __webpack_public_path__ + "static/media/33-1.8d10675c.mp3";